import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "filterCheckbox", "row", "emptyMessage", "visibleCount"]

  connect() {
    this.apply()
  }

  apply() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""
    const requiredRoleIds = this.filterCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)

    let visibleRows = 0

    this.rowTargets.forEach((row) => {
      const rowRoleIds = this.roleIdsFor(row)
      const matchesRoles = requiredRoleIds.every((roleId) => rowRoleIds.includes(roleId))
      const matchesQuery = query.length === 0 || (row.dataset.searchText || "").toLowerCase().includes(query)
      const visible = matchesRoles && matchesQuery

      row.classList.toggle("hidden", !visible)
      if (visible) visibleRows += 1
    })

    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.classList.toggle("hidden", visibleRows > 0)
    }

    if (this.hasVisibleCountTarget) {
      this.visibleCountTarget.textContent = visibleRows.toString()
    }
  }

  roleIdsFor(row) {
    const roleCheckboxes = Array.from(row.querySelectorAll("[data-tenant-role-filter-user-role-checkbox]:checked"))
    if (roleCheckboxes.length > 0) return roleCheckboxes.map((checkbox) => checkbox.value)

    return (row.dataset.roleIds || "").split(",").filter(Boolean)
  }

  preventSubmit(event) {
    event.preventDefault()
  }

  async updateUserRoles(event) {
    const checkbox = event.currentTarget
    const row = checkbox.closest("[data-tenant-role-filter-target='row']")
    if (!row) return

    const roleCheckboxes = Array.from(row.querySelectorAll("[data-tenant-role-filter-user-role-checkbox]"))
    const selectedRoleIds = roleCheckboxes.filter((roleCheckbox) => roleCheckbox.checked).map((roleCheckbox) => roleCheckbox.value)
    const status = row.querySelector("[data-tenant-role-filter-row-status]")
    const previousChecked = !checkbox.checked

    this.setRowStatus(status, "Saving...")
    roleCheckboxes.forEach((roleCheckbox) => { roleCheckbox.disabled = true })

    try {
      const response = await fetch(row.dataset.updateUrl, {
        method: "PATCH",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ tenant_user: { tenant_role_ids: selectedRoleIds } })
      })

      const payload = await response.json()
      if (!response.ok) throw new Error(payload.error || "Roles could not be updated.")

      row.dataset.roleIds = payload.role_ids.join(",")
      this.setRowStatus(status, "Saved")
    } catch (error) {
      checkbox.checked = previousChecked
      this.setRowStatus(status, error.message || "Save failed")
    } finally {
      roleCheckboxes.forEach((roleCheckbox) => { roleCheckbox.disabled = roleCheckbox.dataset.roleLocked === "true" })
      this.apply()
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }

  setRowStatus(status, message) {
    if (!status) return

    status.textContent = message
    if (message === "Saved") {
      window.setTimeout(() => {
        if (status.textContent === "Saved") status.textContent = ""
      }, 1500)
    }
  }
}
